import styled from "styled-components";

export const ModalAlarmStatusBox = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 10px;
  flex-direction: column;
  gap: 4px;
`;

export const ModalAlarmStatusTitle = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;

  .title-box {
    display: flex;
    font-size: 1.6rem;
    font-weight: 500;
    align-items: center;
    gap: 4px;

    span {
      color: ${(props) => props.theme.colors.primary100};
      font-weight: 700;
    }
  }
`;

export const ModalAlarmStatus = styled.div`
  display: flex;
  padding: 12px 0;
  background: ${(props) => props.theme.colors.primary5};
  border-radius: 6px;
  align-items: center;
  justify-content: center;
  gap: 40px;

  div {
    span {
      display: inline-block;
      padding: 0 18px;
      height: 24px;
      margin-left: 8px;
      color: ${(props) => props.theme.colors.white100};
      line-height: 24px;
      border-radius: 12px;
      align-items: center;
      justify-content: center;

      &.critical {
        background: ${(props) => props.theme.colors.redStatus};
      }

      &.warning {
        background: ${(props) => props.theme.colors.yellowStatus};
      }
    }
  }
`;

export const ModalAlarmGridBox = styled.div`
  display: flex;
  width: calc(100vw - 72px);
  max-width: 70vw;
  height: calc(40svh);
  min-height: 80px;
  text-align: left;
  flex-direction: column;
  gap: 8px;

  .ag-theme-quartz {
    .ag-root.ag-layout-normal {
      height: 100%;
    }

    .ag-root-wrapper-body.ag-layout-normal {
      min-height: 100px;
    }
  }
`;
